import React from "react";
import { Form as FormLayout} from "react-bootstrap"
import TextInput from "../../../../Common/components/text-input";

export const SubscriptionSubKey = ({ subKey, setFieldValue, useDefaultSubKey }) => {
    return <>
        <div className="d-flex">
            {
                useDefaultSubKey
                    ? <div
                        className="text-primary cursor-pointer"
                        onClick={() => setFieldValue("useDefaultSubKey", false)}
                    >
                        + Edit Sub Key
                    </div>
                    : <div
                        className="text-danger cursor-pointer ml-auto"
                        onClick={() => setFieldValue("useDefaultSubKey", true)}
                    >
                        - Discard Sub Key
                    </div>
            }
        </div>
        {
            !useDefaultSubKey &&
            <FormLayout.Row className="mt-4">
                <TextInput
                    label="Sub Key*"
                    name="subKey"
                    type="text"
                />
            </FormLayout.Row>
        }
    </>
}